import { Injectable } from '@angular/core';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class HelpService extends BaseService{
  getListHelp(src: string,onSuccess: (data) => void, onError: (data) => void = null): any {
    this.get(`faq?src=${src}`)
        .subscribe(
          resp => {
            onSuccess(resp);
          },
          err => {
            if (onError) {
              onError(err);
            }
          }
        );
  }
}
